var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{attrs:{"label":"Sexe","invalid-feedback":_vm.invalidFeedback}},[_c('b-form-select',{attrs:{"options":_vm.optionsSexe,"value":_vm.sexe,"required":""},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }